import { ColDef } from 'ag-grid-community';
import { AgGridReact } from 'ag-grid-react';
import { RefObject } from 'react';
import { VendorPaymentDetails } from 'pages/VendorPaymentResultPage/types';
import { FailedTableHeader } from './FailedTableHeader';
import { FailedTableSubHeading } from './FailedTableSubHeading';

export const FailedTableHeaderContent = ({
  tableHeaderTitle,
  data,
  gridRef,
  columnDefs
}: {
  tableHeaderTitle: string;
  data: VendorPaymentDetails[];
  gridRef: RefObject<AgGridReact<VendorPaymentDetails>> | undefined;
  columnDefs: ColDef<VendorPaymentDetails>[];
}): React.JSX.Element => (
  <>
    <FailedTableHeader
      tableHeaderTitle={tableHeaderTitle}
      totalRecord={data?.length || 0}
      gridRef={gridRef}
      columnDefs={columnDefs}
    />
    <FailedTableSubHeading />
  </>
);
